import { render } from "./AboutUsComp.vue?vue&type=template&id=6f261e41&scoped=true"
import script from "./AboutUsComp.vue?vue&type=script&lang=js"
export * from "./AboutUsComp.vue?vue&type=script&lang=js"

import "./AboutUsComp.vue?vue&type=style&index=0&id=6f261e41&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f261e41"]])

export default __exports__